module.exports = __webpack_public_path__ + "static/media/cmc.5b75f496.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cmc.png
// module id = 691
// module chunks = 0